import { BankQueryKeys } from '@/modules/bank/keys'
import { useQuery } from '@tanstack/react-query'
import { getChannelCounts } from '../../services'

export default function useQueryChannelCounts() {
	return useQuery({
		queryKey: [BankQueryKeys.ChannelCounts],
		queryFn: () => getChannelCounts(),
	})
}
